import React from "react";
import { nanoid } from "@reduxjs/toolkit";

export const SEUserGroup = () => {
	const id = nanoid();

	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="14" cy="14" r="14" fill={`url(#paint_linear_user_group_${id})`} />
			<g clipPath={`url(#clip_user_group_${id})`}>
				<path
					d="M18.9733 14.4727H17.8906C18.001 14.7748 18.0613 15.1009 18.0613 15.4407V19.5327C18.0613 19.6744 18.0366 19.8104 17.9917 19.9369H19.7817C20.4503 19.9369 20.9943 19.393 20.9943 18.7243V16.4936C20.9943 15.3793 20.0877 14.4727 18.9733 14.4727Z"
					fill="#A8A8A8"
				/>
				<path
					d="M9.93303 15.4407C9.93303 15.1009 9.99333 14.7748 10.1037 14.4727H9.02098C7.90661 14.4727 7 15.3793 7 16.4936V18.7244C7 19.393 7.54395 19.937 8.21259 19.937H10.0026C9.9577 19.8104 9.93303 19.6744 9.93303 19.5327V15.4407Z"
					fill="#A8A8A8"
				/>
				<path
					d="M15.2384 13.4219H12.7632C11.6488 13.4219 10.7422 14.3285 10.7422 15.4429V19.5349C10.7422 19.7581 10.9231 19.9391 11.1464 19.9391H16.8552C17.0784 19.9391 17.2594 19.7581 17.2594 19.5349V15.4429C17.2594 14.3285 16.3528 13.4219 15.2384 13.4219Z"
					fill="#A8A8A8"
				/>
				<path
					d="M14.0008 8.0625C12.6606 8.0625 11.5703 9.15281 11.5703 10.493C11.5703 11.4021 12.072 12.196 12.813 12.6128C13.1645 12.8105 13.5696 12.9235 14.0008 12.9235C14.432 12.9235 14.8371 12.8105 15.1886 12.6128C15.9296 12.196 16.4313 11.402 16.4313 10.493C16.4313 9.15283 15.341 8.0625 14.0008 8.0625Z"
					fill="#A8A8A8"
				/>
				<path
					d="M9.73174 10.3281C8.72945 10.3281 7.91406 11.1435 7.91406 12.1458C7.91406 13.1481 8.72945 13.9635 9.73174 13.9635C9.98598 13.9635 10.2281 13.9108 10.448 13.8162C10.8283 13.6524 11.1418 13.3627 11.3358 12.9997C11.472 12.7449 11.5494 12.4543 11.5494 12.1458C11.5494 11.1435 10.734 10.3281 9.73174 10.3281Z"
					fill="#A8A8A8"
				/>
				<path
					d="M18.2708 10.3281C17.2685 10.3281 16.4531 11.1435 16.4531 12.1458C16.4531 12.4543 16.5306 12.7449 16.6668 12.9997C16.8608 13.3627 17.1743 13.6525 17.5545 13.8162C17.7745 13.9108 18.0166 13.9635 18.2708 13.9635C19.2731 13.9635 20.0885 13.1481 20.0885 12.1458C20.0885 11.1435 19.2731 10.3281 18.2708 10.3281Z"
					fill="#A8A8A8"
				/>
			</g>
			<defs>
				<linearGradient
					id={`paint_linear_user_group_${id}`}
					x1="14"
					y1="0"
					x2="14"
					y2="28"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#C1C1C1" />
					<stop offset="0.0001" stopColor="#EDEDED" />
					<stop offset="1" stopColor="#EDEDED" stopOpacity="0" />
				</linearGradient>
				<clipPath id={`clip_user_group_${id}`}>
					<rect width="14" height="14" fill="white" transform="translate(7 7)" />
				</clipPath>
			</defs>
		</svg>
	);
};
